
import { Component, Vue, Watch } from "vue-property-decorator";
import TramiteCardComponent from "@/components/Common/Cards/TramiteCardComponent.vue";
import PortalServiciosHeader from "@/components/Tramites/PortalServiciosHeader.vue";
import categoryService from "@/services/category.service";

@Component({
  components: {
    PortalServiciosHeader,
    TramiteCardComponent
  }
})
export default class PortalServicios extends Vue {
  private tramite: any = {};

  private async mounted() {
    await this.getTramite();

    if (this.$route.query.scrollTo === "title") {
      this.scrollToTramiteTitle();
    }
  }

  @Watch("$route.params.slug")
  private async onSlugChange() {
    await this.getTramite();

    if (this.$route.query.scrollTo === "title") {
      this.scrollToTramiteTitle();
      return;
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  private async getTramite() {
    const slug = this.$route.params.slug;
    const response = await categoryService.getTramiteBySlug(slug);
    this.tramite = response;
  }
  get hasAnyModality() {
    if (!this.tramite) {
      return false;
    }
    return Boolean(
      this.tramite.in_person ||
      this.tramite.in_web ||
      this.tramite.in_phone ||
      Number(this.tramite.online_percentage) > 0
    );
  }
  get orderedExpansibles() {
    if (!this.tramite || !this.tramite.expansibles) {
      return [];
    }
    return [...this.tramite.expansibles].sort((a: any, b: any) => {
      const orderA = Number(a.order ?? 0);
      const orderB = Number(b.order ?? 0);
      return orderA - orderB;
    });
  }
  private goToTramiteRelacionado(slug: string, scrollToTitle = false) {
    if (!slug) {
      return;
    }

    this.$router.push({
      path: `/portal-servicios/${slug}`,
      query: scrollToTitle ? { scrollTo: "title" } : {}
    });
  }
  private scrollToTramiteTitle() {
    this.$nextTick(() => {
      const title = this.$refs.tramiteTitle as HTMLElement | undefined;
      title?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }
  get processedDescription() {
    const parser = new DOMParser();
    const doc = parser.parseFromString("<div></div>", "text/html");
    const container = doc.body.firstElementChild as HTMLElement;

    container.textContent = this.tramite?.description || "";
    this.linkifyPhoneNumbers(container);

    return container.innerHTML;
  }
  private processedContent(item: any) {
    // Procesar el contenido para envolver blockquote con comillas
    const parser = new DOMParser();
    const doc = parser.parseFromString(item.content, "text/html");

    // Seleccionar todas las etiquetas blockquote
    const blockquotes = doc.querySelectorAll("blockquote");
    blockquotes.forEach((blockquote: any) => {
      blockquote.textContent = `“${blockquote.textContent}”`;
    });

    this.linkifyPhoneNumbers(doc.body as HTMLElement);

    // Devolver el contenido modificado
    return doc.body.innerHTML;
  }
  private linkifyPhoneNumbers(container: HTMLElement) {
    const phonePattern = /(\+?56[\s.-]?)?(\(?0?9\)?[\s.-]?\d{4}[\s.-]?\d{4}|\(?0?[2-7]\)?[\s.-]?(?:\d[\s.-]?)?\d{3}[\s.-]?\d{4})/;
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    const textNodes: Text[] = [];
    let currentNode = walker.nextNode();

    while (currentNode) {
      textNodes.push(currentNode as Text);
      currentNode = walker.nextNode();
    }

    textNodes.forEach(textNode => {
      const parentElement = textNode.parentElement;
      if (!parentElement || parentElement.closest("a")) {
        return;
      }

      const text = textNode.nodeValue || "";
      if (!phonePattern.test(text)) {
        return;
      }

      const ownerDocument = container.ownerDocument || document;
      const fragment = ownerDocument.createDocumentFragment();
      const phoneRegex = new RegExp(phonePattern.source, "g");
      let lastIndex = 0;
      let match = phoneRegex.exec(text);

      while (match) {
        const phoneText = match[0];
        if (match.index > lastIndex) {
          fragment.appendChild(
            ownerDocument.createTextNode(text.slice(lastIndex, match.index))
          );
        }

        const telHref = this.getTelHref(phoneText);
        if (telHref) {
          const link = ownerDocument.createElement("a");
          link.href = telHref;
          link.textContent = phoneText;
          link.className = "phone-link";
          fragment.appendChild(link);
        } else {
          fragment.appendChild(ownerDocument.createTextNode(phoneText));
        }

        lastIndex = match.index + phoneText.length;
        match = phoneRegex.exec(text);
      }

      if (lastIndex < text.length) {
        fragment.appendChild(
          ownerDocument.createTextNode(text.slice(lastIndex))
        );
      }

      if (textNode.parentNode) {
        textNode.parentNode.replaceChild(fragment, textNode);
      }
    });
  }
  private getTelHref(phoneText: string) {
    const normalized = phoneText.replace(/[^\d+]/g, "");
    if (!normalized || normalized.length < 8) {
      return "";
    }
    return `tel:${normalized}`;
  }
  private normalizeExternalUrl(url: string) {
    if (!url) {
      return "";
    }

    const trimmedUrl = url.trim();

    if (/^https?:\/\//i.test(trimmedUrl)) {
      return trimmedUrl;
    }

    return `https://${trimmedUrl}`;
  }
  private toLink(item: any) {
    if (item && item != "") {
      window.open(this.normalizeExternalUrl(item), "_blank");
    } else {
      return;
    }
  }
}
